const discussions_fr = require('./discussions.json')
export default discussions_fr
